export const TIMELINE_CONFIG = {
  // ESCALA: 1 pixel por minuto (1 hora = 60px)
  // Isso faz um dia de 8h (480min) ter 480px de largura.
  PIXELS_PER_MINUTE: 1, 
  
  // Largura Mínima (para cards sem tempo definido não sumirem)
  BASE_WIDTH: 200,
  
  // O SEGREDO: Gap visual mínimo entre cards (apenas para a seta aparecer)
  // Se for muito grande, cria "tempo fantasma" no gráfico.
  NODE_GAP: 30, 

  // Régua de fundo: Desenha uma linha a cada 1 hora (60min)
  GRID_MINUTES_STEP: 60, 
};
